module.exports = __webpack_public_path__ + "static/media/Two_Hand.1c83e515.png";